
import {computed, ComputedRef, defineComponent, inject, PropType, Ref, ref} from "vue";
import {attributeType, attributeTypes} from "@/types/types";
import AttributeModal from "@/components/AttributeModal.vue";
export default defineComponent({
    name: "AttributeValue",
    components: {AttributeModal},
    props: {
        attrData: {
            required: true,
            type: Object as PropType<attributeTypes>
        },
        attrId: {
            required: true,
            type: String
        }
    },
    setup(props) {
        const modal = ref<InstanceType<typeof AttributeModal>>();

        const findAttributeValue = (value) => {
            if (Object.prototype.hasOwnProperty.call(window.attributeData, Number.parseInt(props.attrId))) {
                const attributeObject = window.attributeData[Number.parseInt(props.attrId)];
                return attributeObject.values[value];
            }

            return undefined;
        }

        const selectedAttributes: Ref<Map<number, number | null>> | undefined = inject('selectedAttributes');
        const selectedValue: ComputedRef<attributeType | undefined> = computed(() => {
            return (selectedAttributes && findAttributeValue(selectedAttributes.value.get(Number.parseInt(props.attrId)))) ?? {
                image: "",
                color: "",
                label: ""
            };
        });

        return {
            modal,
            selectedValue
        }
    }
})
